import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField,
} from '@mui/material';
import { useRef, useState } from 'react';
import { PlaceRef } from 'src/entities/Course.entity';

import PlaceAutocomplete from './PlaceAutocomplete';

type Props = { open: boolean; onClose: () => void; onAdd: (place: PlaceRef, arrivalTime: string | null) => void };

/**
 * 末尾に地点を足す。時刻は任意で、順が崩れていれば RouteEditor が送らず知らせる。
 * 地点コード欄（地点コードだけで探す）・地点名欄（名前だけで探す）・住所欄（住所だけで探す）は同じ地点を共有し、
 * どれで選んでもほかの 2 欄に出る（#379・#384）
 */
export default function AddStopDialog({ open, onClose, onAdd }: Props) {
  const [place, setPlace] = useState<PlaceRef | null>(null);
  const [arrival, setArrival] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const reset = () => { setPlace(null); setArrival(''); };
  const close = () => { reset(); onClose(); };
  return (
    <Dialog
      open={open}
      onClose={close}
      maxWidth="xs"
      fullWidth
      // Why not マウント時の effect: Dialog のフォーカストラップに上書きされるので、表示し終えてから focus する
      slotProps={{ transition: { onEntered: () => inputRef.current?.focus() } }}
    >
      <DialogTitle sx={{ fontSize: 16 }}>配送先を追加</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pt: '8px !important' }}>
        <PlaceAutocomplete value={place} onChange={setPlace} label="地点コード" searchBy="internal_location_code" inputRef={inputRef} />
        <PlaceAutocomplete value={place} onChange={setPlace} label="地点名" searchBy="name" />
        <PlaceAutocomplete value={place} onChange={setPlace} label="住所" searchBy="address" />
        <TextField
          size="small"
          type="time"
          label="到着予定"
          value={arrival}
          onChange={(e) => setArrival(e.target.value)}
          slotProps={{ inputLabel: { shrink: true } }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>キャンセル</Button>
        <Button
          variant="contained"
          disableElevation
          disabled={!place}
          onClick={() => {
            if (place) { onAdd(place, arrival || null); reset(); }
          }}
        >
          追加する
        </Button>
      </DialogActions>
    </Dialog>
  );
}
